import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  Form, 
  Button, 
  Alert, 
  Table, 
  Badge, 
  ProgressBar,
  Modal,
  Tabs,
  Tab,
  InputGroup,
  ListGroup,
  Spinner} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import { 
  faCheckCircle, 
  faExclamationTriangle, 
  faEdit, 
  faSave,
  faSearch,
  faArrowRight,
  faBullseye,
  faFileExcel,
  faInfoCircle,
  faChevronDown,
  faChevronUp,
  faTrash,
  faUpload,
  faDownload
} from '@fortawesome/free-solid-svg-icons';
import infomediaService from '../../services/infomediaService';
// ✅ VirtualizedTable eliminado - usando tabla Bootstrap simple
import { MappingSkeleton } from '../common/SkeletonLoaders';
import MultiSelect from '../common/MultiSelect';
import '../../styles/react-select.css';

// Función para obtener nombre del mes
const getMonthName = (monthNumber) => {
  const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];
  return months[monthNumber - 1];
};

const InfomediaMappingInterface = () => {
  // Estados principales
  const [loading, setLoading] = useState(false);
  const [detectingLoading, setDetectingLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  
  // Período y datos
  const [selectedPeriod, setSelectedPeriod] = useState({
    ano: new Date().getFullYear(),
    mes: new Date().getMonth() + 1
  });
  
  // Datos principales
  const [unmappedData, setUnmappedData] = useState([]);
  const [mappingProgress, setMappingProgress] = useState({ total: 0, mapped: 0, pending: 0, filteredPending: 0 });
  const [filteredRecordsCount, setFilteredRecordsCount] = useState(0);
  const [recentMappings, setRecentMappings] = useState([]);
  
  // Estados para manejo de grandes volúmenes
  // Estados para paginación manual
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [recordsPerPage] = useState(50);
  
  // Estados del wizard
  const [activeTab, setActiveTab] = useState('pending');
  // ✅ ELIMINADO: selectedItems (simplificado sin selección múltiple)
  const [currentMapping, setCurrentMapping] = useState(null);
  
  // Filtros y búsqueda optimizados
  const [searchTerm, setSearchTerm] = useState('');

  const [mediumFilter, setMediumFilter] = useState([]);
  const [itemFilter, setItemFilter] = useState([]);
  const [sectorFilter, setSectorFilter] = useState([]);
  const [brandFilter, setBrandFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [itemSearchTerm, setItemSearchTerm] = useState('');
  const [showItemDropdown, setShowItemDropdown] = useState(false);
  const [allAvailableItems, setAllAvailableItems] = useState([]);
  const [allAvailableMedios, setAllAvailableMedios] = useState([]);
  const [allAvailableMarcas, setAllAvailableMarcas] = useState([]);
  const [allAvailableCategories, setAllAvailableCategories] = useState([]);
  const [allAvailableSectores, setAllAvailableSectores] = useState([]);
  const [mappingSearchTerm, setMappingSearchTerm] = useState('');
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [mappingCurrentPage, setMappingCurrentPage] = useState(1);
  const [mappingTotalPages, setMappingTotalPages] = useState(1);
  const [mappingTotalRecords, setMappingTotalRecords] = useState(0);
  const [allDataForSearch, setAllDataForSearch] = useState([]);
  const [loadingMappings, setLoadingMappings] = useState(false);
  
  // ✅ ESTADOS PARA CARGA MASIVA DE EXCEL
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [excelPreview] = useState([]);
  const [uploadingExcel, setUploadingExcel] = useState(false);
  const [excelResults, setExcelResults] = useState(null);
  // ✅ ESTADO PARA MODAL DE INSTRUCCIONES CSV
  const [showCSVInstructionsModal, setShowCSVInstructionsModal] = useState(false);
  // ✅ availableCategories removido - categorías vienen de unmappedData (como medios)
  const sortConfig = useMemo(() => ({
    field: 'cantidadRegistros',
    direction: 'ASC'
  }), []);
  const [filters, setFilters] = useState({
    medio: [],
    item: [],
    sector: [],
    marca: [],
    categoria: [],
    search: ''
  });
  const [lastFilterState, setLastFilterState] = useState(JSON.stringify({
    medio: [],
    item: [],
    sector: [],
    marca: [],
    categoria: [],
    search: ''
  }));
  
  // Estados para el selector de período con buscador y loading
  const [showPeriodDropdown, setShowPeriodDropdown] = useState(false);
  const [periodSearchTerm, setPeriodSearchTerm] = useState('');
  const [isLoadingPeriod, setIsLoadingPeriod] = useState(false);
  
  // Modal de mapeo
  const [showMappingModal, setShowMappingModal] = useState(false);
  const [mappingForm, setMappingForm] = useState({
    versionCliente: '',
    campanaCliente: '',
    segmentoCliente: ''
  });

  // ✅ ELIMINADO: segmentOptions (no usado en tabla simple)

  // ✅ OPCIONES DE PERÍODO CON BUSCADOR
  const periodOptions = useMemo(() => {
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    const currentYear = new Date().getFullYear();
    const options = [];
    
    // Generar opciones desde el año actual hacia atrás hasta 2022
    for (let year = currentYear; year >= 2022; year--) {
      // Para el año actual, solo hasta el mes actual
      const maxMonth = year === currentYear ? new Date().getMonth() + 1 : 12;
      
      // Iterar desde diciembre hacia enero para ordenar por más reciente primero
      for (let mes = maxMonth; mes >= 1; mes--) {
        options.push({
          value: `${year}-${mes}`,
          label: `${months[mes - 1]} ${year}`
        });
      }
    }
    
    return options;
  }, []);

  // ✅ FILTRAR PERÍODOS SEGÚN BÚSQUEDA
  const filteredPeriodOptions = useMemo(() => {
    if (!periodSearchTerm.trim()) return periodOptions;
    const searchTerm = periodSearchTerm.toLowerCase();
    return periodOptions.filter(option => 
      option.label.toLowerCase().includes(searchTerm)
    );
  }, [periodOptions, periodSearchTerm]);

  // ✅ CARGAR SECTORES DISPONIBLES DESDE DIMSECTOR
  const loadAvailableSectores = useCallback(async () => {
    try {

      const response = await infomediaService.getSectores();
      
      if (response.success && response.data) {
        const sectores = response.data.map(sector => sector.name).filter(Boolean);
        setAllAvailableSectores(sectores.sort());

      }
    } catch (error) {
      console.error('Error cargando sectores:', error);
      // Fallback a sectores predefinidos si falla la API
      setAllAvailableSectores(['INTERNET', 'MEDIOS DE COMUNICACION', 'TELECOMUNICACIONES', 'SIN SECTOR']);
    }
  }, []);

  // ✅ CARGAR TODA LA DATA DEL PERÍODO (para todos los filtros y búsquedas)
  const loadAllFilterData = useCallback(async () => {
    try {
      // Cargar una muestra grande para obtener todos los registros únicos
      const response = await infomediaService.getUnmappedRecords(selectedPeriod.ano, selectedPeriod.mes, {
        page: 1,
        limit: 10000, // Límite grande para obtener toda la data
        // Sin filtros para obtener todos los datos
      });
      
      if (response?.data?.items) {
        const allData = response.data.items;
        
        // Extraer items únicos
        const uniqueItems = [...new Set(
          allData
            .filter(item => item.itemOriginal && item.itemOriginal !== 'N/A')
            .map(item => item.itemOriginal)
        )].sort();
        
        // Extraer medios únicos
        const uniqueMedios = [...new Set(
          allData
            .filter(item => item.medioOriginal)
            .map(item => item.medioOriginal)
        )].sort();
        // Extraer marcas únicas
        const uniqueMarcas = [...new Set(
          allData
            .filter(item => item.marcaOriginal)
            .map(item => item.marcaOriginal)
        )].sort();
        // Extraer categorías únicas
        const uniqueCategories = [...new Set(
          allData
            .filter(item => item.categoryOriginal)
            .map(item => item.categoryOriginal)
        )].sort();
        
        // Guardar toda la data para búsqueda general
        setAllDataForSearch(allData);
        setAllAvailableItems(uniqueItems);
        setAllAvailableMedios(uniqueMedios);
        setAllAvailableMarcas(uniqueMarcas);
        setAllAvailableCategories(uniqueCategories);
        
      }
    } catch (error) {
      console.error('Error cargando data para filtros:', error);
      setAllAvailableItems([]);
      setAllAvailableMedios([]);
      setAllDataForSearch([]);
    }
  }, [selectedPeriod.ano, selectedPeriod.mes]);

        // ✅ CARGAR MAPEOS RECIENTES + ESTADÍSTICAS COMPLETAS (OPTIMIZADO)
  const loadRecentMappings = useCallback(async (page = 1) => {
    setLoadingMappings(true);
    try {
      const limit = 10;
      const offset = (page - 1) * limit;
      
      
      // UNA SOLA LLAMADA: mapeos recientes para tabla
      const response = await infomediaService.getMappings(selectedPeriod.ano, selectedPeriod.mes, {
        limit,
        offset
      });
      
      
      // ✅ ACTUALIZAR MAPEOS RECIENTES (estructura correcta: response.data.items)
      if (response?.data?.items && Array.isArray(response.data.items)) {
        setRecentMappings(response.data.items);
        setMappingCurrentPage(page);
        setMappingTotalRecords(response.data.total || 0);
        setMappingTotalPages(Math.ceil((response.data.total || 0) / limit));
        
        
        // ✅ USAR EL TOTAL DE LA RESPUESTA PARA ESTADÍSTICAS
        const totalMapped = response.data.total || 0;
        
        // Actualizar estadísticas
        setMappingProgress(prev => ({
          ...prev,
          mapped: totalMapped
        }));
        
      } else {
        console.warn('⚠️ No se encontraron mapeos o estructura incorrecta:', response);
        setRecentMappings([]);
        // Si no hay datos, actualizar estadísticas a 0
        setMappingProgress(prev => ({
          ...prev,
          mapped: 0
        }));
      }
      
    } catch (error) {
      console.error('❌ Error cargando mapeos recientes:', error);
      setRecentMappings([]);
      setMappingProgress(prev => ({
        ...prev,
        mapped: 0
      }));
    } finally {
      setLoadingMappings(false);
    }
  }, [selectedPeriod.ano, selectedPeriod.mes]);

  // ✅ ELIMINADO: getMedioSector - Ahora usamos sectorOriginal directamente del backend

  // ✅ FILTRAR LOCALMENTE CON TODA LA DATA DEL PERÍODO
  const filterAllData = useCallback(() => {
    if (!allDataForSearch.length) return [];
    
    let filteredData = [...allDataForSearch];
    
    // Aplicar filtro de búsqueda general
    if (filters.search && filters.search.trim()) {
      const searchTerm = filters.search.toLowerCase();
      filteredData = filteredData.filter(item => 
        (item.campanaOriginal && item.campanaOriginal.toLowerCase().includes(searchTerm)) ||
        (item.versionOriginal && item.versionOriginal.toLowerCase().includes(searchTerm)) ||
        (item.medioOriginal && item.medioOriginal.toLowerCase().includes(searchTerm)) ||
        (item.itemOriginal && item.itemOriginal.toLowerCase().includes(searchTerm))
      );
    }
    

    
    // Aplicar filtro de medio (multiselect)
    if (Array.isArray(filters.medio) && filters.medio.length > 0) {
      const medioSet = new Set(filters.medio);
      filteredData = filteredData.filter(item => item.medioOriginal && medioSet.has(item.medioOriginal));
    }
    
    // Aplicar filtro de item (multiselect)
    if (Array.isArray(filters.item) && filters.item.length > 0) {
      const itemSet = new Set(filters.item);
      filteredData = filteredData.filter((row) => row.itemOriginal && itemSet.has(row.itemOriginal));
    }
    
    // ✅ Aplicar filtro de sectores (multiselect)
    if (filters.sector && Array.isArray(filters.sector) && filters.sector.length > 0) {
      filteredData = filteredData.filter(item => {
        // Usar sectorOriginal del backend, o mapeo temporal si no existe
        let itemSector = item.sectorOriginal;
        
        if (!itemSector) {
          // Mapeo temporal para datos sin sectorOriginal
          const medioMapped = item.medioOriginal === 'Digital' ? 'Internet' : item.medioOriginal;
          
          if (medioMapped === 'Internet') itemSector = 'INTERNET';
          else if (medioMapped === 'Radio') itemSector = 'MEDIOS DE COMUNICACIÓN';
          else if (medioMapped === 'TV') itemSector = 'MEDIOS DE COMUNICACIÓN'; 
          else if (medioMapped === 'Prensa') itemSector = 'MEDIOS DE COMUNICACIÓN';
          else if (medioMapped === 'Vía Pública' || medioMapped === 'VP') itemSector = 'TELECOMUNICACIONES';
          else itemSector = 'SIN SECTOR';
        }
        
        return filters.sector.includes(itemSector);
      });
    }

    // ✅ Aplicar filtro de marcas (multiselect)
    if (filters.marca && Array.isArray(filters.marca) && filters.marca.length > 0) {
      const marcaSet = new Set(filters.marca);
      filteredData = filteredData.filter(item => item.marcaOriginal && marcaSet.has(item.marcaOriginal));
    }

    // ✅ Aplicar filtro de categorías (multiselect)
    if (filters.categoria && Array.isArray(filters.categoria) && filters.categoria.length > 0) {
      const catSet = new Set(filters.categoria);
      filteredData = filteredData.filter(item => item.categoryOriginal && catSet.has(item.categoryOriginal));
    }
    
    // Ordenar
    filteredData.sort((a, b) => {
      const aValue = a[sortConfig.field] || '';
      const bValue = b[sortConfig.field] || '';
      
      if (sortConfig.direction === 'ASC') {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });
    
    return filteredData;
  }, [allDataForSearch, filters, sortConfig]);

  // ✅ CARGAR DATOS CON PAGINACIÓN MANUAL (NO scroll infinito)
  const loadData = useCallback(async (pageToLoad = null, forceRefresh = false) => {
      setLoading(true);
      setError(null);
    
    try {
      const page = pageToLoad || currentPage;
      
      // 🔍 Si hay filtros aplicados (búsqueda O filtros dropdown), usar filtrado local
      const hasActiveFilters = (
        (filters.search && filters.search.trim()) ||
        (Array.isArray(filters.medio) && filters.medio.length > 0) ||
        (Array.isArray(filters.item) && filters.item.length > 0) ||
        (filters.sector && Array.isArray(filters.sector) && filters.sector.length > 0) ||
        (filters.marca && Array.isArray(filters.marca) && filters.marca.length > 0) ||
        (filters.categoria && Array.isArray(filters.categoria) && filters.categoria.length > 0)
      );
      
      
      if (hasActiveFilters && allDataForSearch.length > 0 && !forceRefresh) {
        
        const filteredData = filterAllData();
        const totalFiltered = filteredData.length;
        
        // Asegurarnos de que la página actual es válida
        const maxPage = Math.ceil(totalFiltered / recordsPerPage);
        const validPage = Math.min(page, maxPage || 1);
        
        const startIndex = (validPage - 1) * recordsPerPage;
        const endIndex = startIndex + recordsPerPage;
        const pageData = filteredData.slice(startIndex, endIndex);
        

        
        setUnmappedData(pageData);
        setFilteredRecordsCount(totalFiltered);
        setTotalPages(Math.ceil(totalFiltered / recordsPerPage) || 1);
        setCurrentPage(validPage); // ✅ ACTUALIZAR PÁGINA ACTUAL
        
        // Actualizar progreso con registros filtrados
        setMappingProgress(prev => ({
          ...prev,
          filteredPending: totalFiltered
        }));
        
        setLoading(false);
        return;
      }
      
      // 🌐 Si NO hay filtros O si se fuerza refresh, usar API normal sin filtrado local
      if (forceRefresh) {
      } else {
      }
      
      // Llamada a la API con paginación
      const unmappedResponse = await infomediaService.getUnmappedRecords(selectedPeriod.ano, selectedPeriod.mes, {
        page: page,
        limit: recordsPerPage,
        offset: (page - 1) * recordsPerPage,
        medio: Array.isArray(filters.medio) && filters.medio.length > 0 ? filters.medio.join(',') : undefined,
        item: Array.isArray(filters.item) && filters.item.length > 0 ? filters.item.join(',') : undefined,
        sector: Array.isArray(filters.sector) && filters.sector.length > 0 ? filters.sector.join(',') : undefined,
        marca: Array.isArray(filters.marca) && filters.marca.length > 0 ? filters.marca.join(',') : undefined,
        categoria: Array.isArray(filters.categoria) && filters.categoria.length > 0 ? filters.categoria.join(',') : undefined,
        sortBy: sortConfig?.field,
        sortOrder: sortConfig?.direction || 'DESC'
      });
      


      // VERIFICAR DATOS USANDO ESTRUCTURA CORRECTA: response.data.items
      if (!unmappedResponse.data?.items || unmappedResponse.data.items.length === 0) {
        console.warn('⚠️ NO HAY DATOS DEVUELTOS:', {
          total: unmappedResponse.data?.pagination?.total,
          items_length: unmappedResponse.data?.items?.length,
          filters_applied: filters,
          period: selectedPeriod,
          data_existe: !!unmappedResponse.data,
          items_existe: !!unmappedResponse.data?.items
        });
      } else {
      }

      // ✅ ACTUALIZAR DATOS - SOLO LA PÁGINA ESPECÍFICA (NO acumular)
      setUnmappedData(unmappedResponse.data?.items || []);
      const totalPending = unmappedResponse.data?.pagination?.total || 0;
      setFilteredRecordsCount(totalPending);
      setMappingProgress(prev => ({
        total: (prev.mapped || 0) + totalPending, // Total = mapeados + pendientes
        mapped: prev.mapped || 0, // Mantener los mapeados cargados por loadRecentMappings
        pending: totalPending,
        filteredPending: totalPending // Cuando se usa la API, los filtrados son los mismos que los pendientes
      }));
      
      // Actualizar paginación
      const totalPagesCount = Math.ceil(totalPending / recordsPerPage);
      setTotalPages(totalPagesCount);
      if (pageToLoad) {
        setCurrentPage(pageToLoad);
      }

      // Actualizar información de paginación
      if (unmappedResponse.data?.pagination) {
        const totalPages = unmappedResponse.data.pagination.totalPages || Math.ceil(unmappedResponse.data.pagination.total / recordsPerPage) || 1;
        setTotalPages(totalPages);
        
        // Validar que la página actual es válida
        if (page > totalPages) {
          setCurrentPage(totalPages);
          loadData(totalPages);
          return;
        }
        
        // ✅ ACTUALIZAR PÁGINA ACTUAL después de validar
        setCurrentPage(page);
      }


    } catch (err) {
      console.error('❌ Error cargando datos:', err);
      setError('Error al cargar los datos de mapeo: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [selectedPeriod, recordsPerPage, filters, sortConfig]); // Eliminar dependencias que causan bucles

  // ✅ ELIMINAR MAPEO EXISTENTE
  const handleEditMapping = useCallback((mapping) => {
    setSelectedMapping(mapping);
    setCurrentMapping(mapping); // Asegurar que el modal tenga datos
    setMappingForm({
      versionCliente: mapping.versionCliente,
      campanaCliente: mapping.campanaCliente,
      segmentoCliente: mapping.segmentoCliente || ''
    });
    setShowMappingModal(true);
  }, []);

  const handleDeleteMapping = useCallback(async (mappingId, mappingInfo) => {
    const confirmMessage = `¿Estás seguro de que deseas eliminar este mapeo?

Original: ${mappingInfo.versionOriginal} - ${mappingInfo.campanaOriginal}
Cliente: ${mappingInfo.versionCliente} - ${mappingInfo.campanaCliente}
Segmento: ${mappingInfo.segmentoCliente}

Esta acción no se puede deshacer.`;

    if (window.confirm(confirmMessage)) {
      try {
        setLoading(true);
        await infomediaService.deleteMapping(mappingId);
        setSuccess(`Mapeo eliminado exitosamente: ${mappingInfo.versionOriginal}. El registro debería reaparecer en "Listos para Mapear".`);
        
        
        // ✅ RE-INSERCIÓN INTELIGENTE - Agregar registro de vuelta sin recargar tabla
        const registroReinsertado = {
          medioOriginal: mappingInfo.medioOriginal,
          versionOriginal: mappingInfo.versionOriginal,
          campanaOriginal: mappingInfo.campanaOriginal,
          itemOriginal: mappingInfo.itemOriginal
        };
        
        
        // ✅ Validar que todos los campos estén presentes
        if (!registroReinsertado.medioOriginal || !registroReinsertado.versionOriginal || !registroReinsertado.campanaOriginal) {
          console.error('❌ ERROR: Campos críticos faltantes para re-inserción:', {
            medioOriginal: registroReinsertado.medioOriginal ? '✅' : '❌ FALTA',
            versionOriginal: registroReinsertado.versionOriginal ? '✅' : '❌ FALTA', 
            campanaOriginal: registroReinsertado.campanaOriginal ? '✅' : '❌ FALTA',
            itemOriginal: registroReinsertado.itemOriginal ? '✅' : '❌ FALTA (opcional)'
          });
        } else {
        }
        
        // ✅ Esperar un momento para que el backend complete la re-inserción
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // ✅ 1. Solo recargar mapeos recientes (quitar de ahí)
        await loadRecentMappings(1);
        
        // ✅ 2. Agregar a cache y vista actual (si cumple filtros actuales)
        // Necesitamos verificar si debería aparecer con los filtros actuales
        const hasActiveFilters = (
          (filters.search && filters.search.trim()) ||
          (Array.isArray(filters.medio) && filters.medio.length > 0) ||
          (Array.isArray(filters.item) && filters.item.length > 0) ||
          (Array.isArray(filters.sector) && filters.sector.length > 0) ||
          (Array.isArray(filters.marca) && filters.marca.length > 0) ||
          (Array.isArray(filters.categoria) && filters.categoria.length > 0)
        );
        
        if (hasActiveFilters) {
          
          // Verificar si el registro cumple con los filtros actuales
          const cumpleFiltros = (
            (filters.medio?.length === 0 || filters.medio?.includes(registroReinsertado.medioOriginal)) &&
            (!filters.item || filters.item.length === 0 || filters.item.includes(registroReinsertado.itemOriginal)) &&
            (!filters.sector || filters.sector.length === 0 || filters.sector.includes(registroReinsertado.sectorOriginal)) &&
            (!filters.marca || filters.marca.length === 0 || filters.marca.includes(registroReinsertado.marcaOriginal)) &&
            (!filters.categoria || filters.categoria.length === 0 || filters.categoria.includes(registroReinsertado.categoryOriginal)) &&
            true // Sin filtro de prioridad
          );
          
          if (cumpleFiltros) {
            await loadAllFilterData(); // Recargar cache para incluir el registro re-insertado
            await loadData(currentPage, true); // Recargar página actual
          } else {
          }
        } else {
          await loadData(1, true); // Ir a página 1 y recargar
        }
        
      } catch (error) {
        setError(`Error eliminando mapeo: ${error.message}`);
      } finally {
        setLoading(false);
      }
    }
  }, [loadData, loadRecentMappings, loadAllFilterData, filters, currentPage]);

  // ✅ FUNCIÓN PARA DESCARGAR CSV DE REGISTROS SIN MAPEAR
  const downloadUnmappedCSV = useCallback(async () => {
    try {
      setLoading(true);
      toast.info('Preparando descarga de registros filtrados...', { autoClose: 2000 });

      // Usar los mismos filtros que están activos en la tabla
      // ✅ INCLUIR TODOS LOS FILTROS: medio, item, sector, marca, categoria
      const hasActiveFilters = (
        (filters.search && filters.search.trim()) ||
        (Array.isArray(filters.medio) && filters.medio.length > 0) ||
        (Array.isArray(filters.item) && filters.item.length > 0) ||
        (Array.isArray(filters.sector) && filters.sector.length > 0) ||
        (Array.isArray(filters.marca) && filters.marca.length > 0) ||
        (Array.isArray(filters.categoria) && filters.categoria.length > 0)
      );

      console.log('📥 Descarga CSV - hasActiveFilters:', hasActiveFilters);
      console.log('📥 Descarga CSV - filters:', filters);
      console.log('📥 Descarga CSV - allDataForSearch.length:', allDataForSearch.length);

      // Si hay filtros activos, usar filtrado local
      let recordsToDownload = [];
      
      if (hasActiveFilters && allDataForSearch.length > 0) {
        // ✅ CORRECCIÓN: filterAllData() no recibe parámetros, usa el contexto directamente
        recordsToDownload = filterAllData();
        console.log('📥 Descarga CSV - registros filtrados:', recordsToDownload.length);
      } else {
        const response = await infomediaService.getUnmappedRecords(
          selectedPeriod.ano,
          selectedPeriod.mes,
          {
            page: 1,
            limit: 10000,
            sortBy: sortConfig?.field,
            sortOrder: sortConfig?.direction || 'DESC'
          }
        );
        
        if (!response?.success || !response?.data?.items) {
          throw new Error('Error obteniendo registros');
        }
        
        recordsToDownload = response.data.items;
      }


      if (recordsToDownload.length === 0) {
        toast.warning('No hay registros que cumplan con los filtros seleccionados');
        return;
      }

      // Generar CSV (formato para mapeo offline) - INCLUYE TODOS LOS CAMPOS NECESARIOS
      // ✅ USAR PUNTO Y COMA PARA COMPATIBILIDAD CON EXCEL EN ESPAÑOL/LATINOAMÉRICA
      const headers = [
        'ANO', 'MES', 'MEDIO', 'VERSIONINFOMEDIA', 'CAMPANAINFOMEDIA', 'ITEMINFOMEDIA', 'MARCAINFOMEDIA', 'CATEGORIAINFOMEDIA', 'VERSIONCLIENTE', 'CAMPANACLIENTE', 'SEGMENTOCLIENTE'
      ];

      const csvRows = recordsToDownload.map(record => [
        record.ano || selectedPeriod.ano,
        record.mes || selectedPeriod.mes,
        record.medioOriginal || '',
        record.versionOriginal || '',
        record.campanaOriginal || '',
        record.itemOriginal || '',
        record.marcaOriginal || '',
        record.categoryOriginal || '',
        '', // VersionCliente - para llenar
        '', // CampanaCliente - para llenar
        ''  // SegmentoCliente - para llenar
      ].map(field => `"${String(field || '').replace(/"/g, '""')}"`).join(';')); // ✅ Usar punto y coma

      const csvContent = [headers.join(';'), ...csvRows].join('\n'); // ✅ Usar punto y coma
      
      // Agregar BOM para Excel y descargar
      const BOM = '\uFEFF';
      const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = url;
      link.download = `infomedia_sin_mapear_${selectedPeriod.ano}_${String(selectedPeriod.mes).padStart(2, '0')}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      toast.success(`Archivo CSV descargado correctamente (${recordsToDownload.length} registros)`, { autoClose: 3000 });
      
      // ✅ Mostrar modal con instrucciones para Windows/Excel
      setShowCSVInstructionsModal(true);
    } catch (error) {
      console.error('Error al descargar CSV:', error);
      toast.error(`Error al descargar: ${error.message}`);
    } finally {
      setLoading(false);
    }
  }, [selectedPeriod, filters, sortConfig, filterAllData, allDataForSearch]);

  // ✅ FUNCIÓN PARA DESCARGAR CSV DE MAPEOS
  const downloadMappingsCSV = useCallback(async () => {
    try {
      if (!recentMappings || recentMappings.length === 0) {
        alert('No hay mapeos para descargar');
        return;
      }

      // Crear CSV con los mapeos
      const headers = [
        'Ano', 'Mes', 'MedioOriginal', 'VersionOriginal', 'CampanaOriginal', 'Categoria', 'Marca', 'VersionCliente', 'CampanaCliente', 'SegmentoCliente',
        'Usuario', 'FechaCreacion'
      ];

      const csvContent = [
        headers.join(','),
        ...recentMappings.map(mapping => [
          mapping.ano || selectedPeriod.ano,
          mapping.mes || selectedPeriod.mes,
          mapping.medioOriginal || '',
          mapping.versionOriginal || '',
          mapping.campanaOriginal || '',
          mapping.marcaOriginal || '',
          mapping.categoryOriginal || '',
          mapping.versionCliente || '',
          mapping.campanaCliente || '',
          mapping.segmentoCliente || '',
          mapping.usuario || '',
          mapping.fechaCreacion ? new Date(mapping.fechaCreacion).toLocaleDateString() : ''
        ].map(field => `"${String(field).replace(/"/g, '""')}"`).join(','))
      ].join('\n');

      // Crear y descargar archivo
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `infomedia_mapeos_${selectedPeriod.ano}_${String(selectedPeriod.mes).padStart(2, '0')}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error descargando CSV de mapeos:', error);
      alert('Error al descargar el archivo CSV');
    }
  }, [recentMappings, selectedPeriod]);

  // ✅ FUNCIONES PARA CARGA MASIVA DE EXCEL
  const handleExcelFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setExcelFile(file);
      // Aquí podrías agregar lógica para preview del Excel si quieres
    }
  };

  const handleExcelUpload = async () => {
    if (!excelFile) {
      setError('Por favor selecciona un archivo Excel');
      return;
    }

    setUploadingExcel(true);
    setError(null);
    
    try {
      const formData = new FormData();
      formData.append('excelFile', excelFile);
      formData.append('ano', selectedPeriod.ano);
      formData.append('mes', selectedPeriod.mes);

      
      // Llamar al nuevo endpoint de carga masiva
      const response = await infomediaService.uploadMassiveMapping(formData);
      const results = response?.data ?? response;

      setExcelResults(results);

      if ((results?.mapped ?? 0) > 0) {
        setSuccess(
          `Carga masiva completada: ${results.processed} filas procesadas, ${results.mapped} mapeos creados, ${results.omitidos ?? 0} omitidos.`
        );
        await loadData();
        await loadRecentMappings(1);
        setShowExcelModal(false);
        setExcelFile(null);
      } else {
        setError(
          `La carga terminó pero no se creó ningún mapeo. Procesados: ${results?.processed ?? 0}, omitidos: ${results?.omitidos ?? 0}. ` +
          'Verifique que ejecutó "Detectar sin mapear" para el período y que las columnas de Infomedia no fueron modificadas en el CSV.'
        );
      }
      
    } catch (err) {
      console.error('❌ Error en carga masiva:', err);
      setError(`Error en carga masiva: ${err.message}`);
    } finally {
      setUploadingExcel(false);
    }
  };

  // ✅ CATEGORÍAS se extraen automáticamente de unmappedData (como medios) - sin consulta extra





  // Manejar cambio de página - SIEMPRE usar filtrado local si hay filtros
  const handlePageChange = useCallback(async (newPage) => {
    // Verificar si hay filtros activos
    const hasActiveFilters = (
      (filters.search && filters.search.trim()) ||
      (Array.isArray(filters.medio) && filters.medio.length > 0) ||
      (Array.isArray(filters.item) && filters.item.length > 0) ||
      (filters.sector && Array.isArray(filters.sector) && filters.sector.length > 0) ||
      (filters.marca && Array.isArray(filters.marca) && filters.marca.length > 0) ||
      (filters.categoria && Array.isArray(filters.categoria) && filters.categoria.length > 0)
    );
    
    
    // Si hay filtros, asegurar que use filtrado local
    if (hasActiveFilters && allDataForSearch.length === 0) {
      await loadAllFilterData();
    }
    
    await loadData(newPage, false); // Nunca forzar refresh en paginación
  }, [filters, allDataForSearch, loadAllFilterData]);

  // ✅ MANEJAR CAMBIO DE PERÍODO CON LOADING
  const handlePeriodChange = useCallback(async (ano, mes) => {
    try {
      setIsLoadingPeriod(true);
      setSelectedPeriod({ ano: parseInt(ano), mes: parseInt(mes) });
      setShowPeriodDropdown(false);
      setPeriodSearchTerm('');
      
      // El useEffect se encarga del resto cuando cambie selectedPeriod
      // El loading se desactiva en el useEffect después de cargar todos los datos
    } catch (error) {
      console.error('Error al cambiar período:', error);
      toast.error('Error al cambiar período');
      setIsLoadingPeriod(false); // Desactivar loading si hay error
    }
  }, []);

  // ✅ CARGAR DATOS INICIAL (solo una vez al montar el componente)
  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setIsInitialLoad(false); // Marca que ya estamos cargando
        
        // Cargar datos en paralelo para mejor performance
        await Promise.all([
          loadAllFilterData(),
          loadAvailableSectores(),
          loadData(1, true), // Forzar refresh para usar API directamente
          loadRecentMappings(1)
        ]);
        
        setFilteredMappings([]);
      } catch (error) {
        console.error('❌ Error en carga inicial:', error);
      }
    };
    loadInitialData();
  }, []); // Solo una vez al montar

  // ✅ CARGAR TODA LA DATA CUANDO CAMBIE EL PERÍODO (sin bucles)
  useEffect(() => {
    // Evitar que se ejecute en la carga inicial
    if (isInitialLoad) {
      return;
    }

    const loadPeriodData = async () => {
      try {
        // Solo cargar datos del nuevo período, MANTENER filtros actuales
        setCurrentPage(1); // Resetear a página 1
        
        // Cargar datos necesarios: primero ALL data, luego los específicos
        await loadAllFilterData(); // NECESARIO para tener datos para filtrado local
        
        await Promise.all([
          loadData(1, true), // Solo los datos de la tabla
          loadRecentMappings(1) // Solo los mapeos recientes
        ]);
        
        // Mantener filtros actuales pero asegurar que tenemos los datos del nuevo período
      } catch (error) {
        console.error('❌ Error cambiando período:', error);
      } finally {
        // Desactivar loading del período cuando termine de cargar los datos
        setIsLoadingPeriod(false);
      }
    };
    loadPeriodData();
  }, [selectedPeriod.ano, selectedPeriod.mes]);

  // ✅ RECARGAR DATOS CUANDO CAMBIEN FILTROS (simplificado para evitar bucles)
  useEffect(() => {
    // Evitar que se ejecute en la carga inicial
    if (isInitialLoad) {
      return;
    }

    const currentFilterState = JSON.stringify(filters);
    
    // Solo ejecutar si realmente cambiaron los filtros
    if (currentFilterState === lastFilterState) {
      return;
    }

    const debounceTimer = setTimeout(() => {
      setCurrentPage(1);
      setLastFilterState(currentFilterState);
      loadData(1, false).then(() => {
        loadRecentMappings(1);
      });
    }, 500); // Reducir debounce para mejor UX

    return () => clearTimeout(debounceTimer);
  }, [filters, isInitialLoad, lastFilterState]); // Agregar dependencias necesarias

  // Manejar cambios en filtros
  const handleFilterChange = useCallback((filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
    
    // Actualizar estados individuales para compatibilidad
    if (filterType === 'medio') setMediumFilter(value);
    if (filterType === 'item') setItemFilter(Array.isArray(value) ? value : (value ? [value] : []));
    if (filterType === 'sector') setSectorFilter(Array.isArray(value) ? value : []);
    if (filterType === 'search') setSearchTerm(value);
  }, []);

  // Filtrar items disponibles basado en el término de búsqueda (usando TODOS los items del período)
  const filteredItems = useMemo(() => {
    if (!itemSearchTerm) {
      return allAvailableItems.map((x) => ({ value: x, label: x }));
    }
    const lc = itemSearchTerm.toLowerCase();
    return allAvailableItems
      .filter((item) => item.toLowerCase().includes(lc))
      .map((x) => ({ value: x, label: x }));
  }, [allAvailableItems, itemSearchTerm]);

  // Preparar opciones para el selector de sectores
  const sectorOptions = useMemo(() => {
    return allAvailableSectores.map(sector => ({
      value: sector,
      label: sector
    }));
  }, [allAvailableSectores]);

  // ✅ BUSCAR EN TODOS LOS MAPEOS DEL BACKEND (NO SOLO LA PÁGINA ACTUAL)
  const [allMappings, setAllMappings] = useState([]);
  const [searchingMappings, setSearchingMappings] = useState(false);
  const [filteredMappings, setFilteredMappings] = useState([]);

  const searchAllMappings = useCallback(async (searchTerm) => {
    if (!searchTerm.trim()) {
      setFilteredMappings(recentMappings);
      return;
    }

    setSearchingMappings(true);
    try {
      // Buscar en todos los mapeos del backend
      const response = await infomediaService.getMappings(
        selectedPeriod.ano, 
        selectedPeriod.mes, 
        { limit: 1000, offset: 0 } // Obtener muchos más registros para buscar
      );

      if (response?.data?.items) {
        const searchTermLower = searchTerm.toLowerCase();
        const filtered = response.data.items.filter(mapping => 
          mapping.versionOriginal?.toLowerCase().includes(searchTermLower) ||
          mapping.campanaOriginal?.toLowerCase().includes(searchTermLower) ||
          mapping.versionCliente?.toLowerCase().includes(searchTermLower) ||
          mapping.campanaCliente?.toLowerCase().includes(searchTermLower) ||
          mapping.medioOriginal?.toLowerCase().includes(searchTermLower) ||
          mapping.sectorOriginal?.toLowerCase().includes(searchTermLower) ||
          mapping.segmentoCliente?.toLowerCase().includes(searchTermLower)
        );
        
        setFilteredMappings(filtered);
        setAllMappings(response.data.items);
      }
    } catch (error) {
      console.error('❌ Error buscando mapeos:', error);
      setFilteredMappings(recentMappings);
    } finally {
      setSearchingMappings(false);
    }
  }, [selectedPeriod.ano, selectedPeriod.mes, recentMappings]);



  // Configuración de columnas para tabla virtualizada
  const tableColumns = [
    // ✅ ELIMINADO: Checkbox de selección (simplificar por ahora)
    {
      key: 'medioOriginal',
      title: 'Medio',
      sortable: true,
      width: '100px',
      render: (value) => {
        // ✅ COLORES DISTINTOS Y VISIBLES PARA CADA MEDIO - RESPONSIVE
        const getMedioColor = (medio) => {
          const medioLower = medio?.toLowerCase() || '';
          if (medioLower.includes('radio')) return 'primary';
          if (medioLower.includes('tv') || medioLower.includes('television')) return 'success';
          if (medioLower.includes('internet') || medioLower.includes('digital') || medioLower.includes('web')) return 'info';
          if (medioLower.includes('prensa') || medioLower.includes('periodico') || medioLower.includes('diario')) return 'warning';
          if (medioLower.includes('revista') || medioLower.includes('magazine')) return 'danger';
          if (medioLower.includes('outdoor') || medioLower.includes('valla') || medioLower.includes('billboard')) return 'dark';
          return 'secondary';
        };

        return (
          <Badge 
            bg={getMedioColor(value)}
            className="px-2 py-1 fw-bold text-uppercase d-block text-center"
            style={{
              fontSize: '10px',
              letterSpacing: '0.3px',
              minWidth: '60px',
              borderRadius: '4px',
              border: '1px solid rgba(255,255,255,0.2)',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
          >
            {value || 'N/A'}
        </Badge>
        );
      }
    },
    {
      key: 'versionOriginal',
      title: 'Versión',
      sortable: true,
      width: '180px',
      cellClassName: 'fw-medium',
      render: (value) => (
        <div className="text-truncate" style={{ maxWidth: '160px' }} title={value}>
          <span className="fw-medium text-dark" style={{ fontSize: '12px', lineHeight: '1.3' }}>
            {value}
          </span>
        </div>
      )
    },
    {
      key: 'campanaOriginal',
      title: 'Campaña',
      sortable: true,
      width: '160px',
      render: (value) => (
        <div className="text-truncate" style={{ maxWidth: '140px' }} title={value}>
          <span className="fw-normal text-secondary" style={{ fontSize: '12px', lineHeight: '1.3' }}>
            {value}
          </span>
        </div>
      )
    },
    {
      key: 'itemOriginal',
      title: 'Item',
      sortable: true,
      width: '120px',
      render: (value) => (
        <div className="text-center">
          <Badge 
            bg="outline-dark"
            className="px-2 py-1 fw-bold text-uppercase border border-secondary"
            style={{
              fontSize: '10px',
              letterSpacing: '0.3px',
              color: '#495057',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px'
            }}
          >
            {value || 'N/A'}
          </Badge>
        </div>
      )
    },
    {
      key: 'sectorOriginal',
      title: 'Sector',
      sortable: true,
      width: '140px',
      render: (value) => (
        <div className="text-center">
          <Badge 
            bg={value === 'INTERNET' ? 'info' : value === 'MEDIOS DE COMUNICACIÓN' ? 'warning' : value === 'TELECOMUNICACIONES' ? 'success' : 'secondary'}
            className="px-2 py-1"
            style={{ fontSize: '10px' }}
          >
            {value || 'SIN SECTOR'}
          </Badge>
        </div>
      )
    },
    {
      key: 'marcaOriginal',
      title: 'Marca',
      sortable: true,
      width: '140px',
      render: (value) => (
        <div className="text-center">
          <Badge bg="light" text="dark" className="px-2 py-1" style={{ fontSize: '10px' }}>
            {value || '—'}
          </Badge>
        </div>
      )
    },
    {
      key: 'categoryOriginal',
      title: 'Categoría',
      sortable: true,
      width: '140px',
      render: (value) => (
        <div className="text-center">
          <Badge bg="secondary" className="px-2 py-1" style={{ fontSize: '10px' }}>
            {value || '—'}
          </Badge>
        </div>
      )
    },
    {
      key: 'cantidadRegistros',
      title: 'Registros',
      sortable: true,
      type: 'number',
      width: '90px',
      render: (value) => (
        <div className="text-center">
          <span className="fw-bold text-primary" style={{ fontSize: '11px' }}>
          {formatNumber(value)}
        </span>
        </div>
      )
    },
    {
      key: 'totalTarifa',
      title: 'Tarifa',
      sortable: true,
      width: '110px',
      render: (value) => (
        <div className="text-end">
          <span className="fw-medium text-success" style={{ fontSize: '11px' }}>
            ${formatNumber(value)}
          </span>
        </div>
      )
    },

    {
      key: 'urgencia',
      title: 'Urgencia',
      width: '70px',
      render: (value, item) => (
        <div className="text-center">
          <div 
            className="progress" 
            style={{ height: '6px', minWidth: '40px' }}
            title={`Urgencia: ${value || 0}%`}
          >
            <div 
              className={`progress-bar ${
                (value || 0) > 80 ? 'bg-danger' : 
                (value || 0) > 60 ? 'bg-warning' : 'bg-info'
              }`}
              style={{ width: `${value || 0}%` }}
            />
          </div>
          <small className="text-muted" style={{ fontSize: '9px' }}>{value || 0}%</small>
        </div>
      )
    },
    {
      key: 'actions',
      title: 'Acciones',
      width: '90px',
      render: (_, item) => (
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => handleStartMapping(item)}
          className="px-2 py-1"
          style={{ fontSize: '10px' }}
        >
          <FontAwesomeIcon icon={faEdit} />
          <span className="d-none d-lg-inline ms-1">Mapear</span>
        </Button>
      )
    }
  ];

  // Los datos ya vienen filtrados del servidor, no necesitamos filtrar en cliente
  const filteredUnmappedData = unmappedData;

  // ✅ ELIMINADO: Funciones de selección múltiple (simplificado)

  // ✅ Abrir modal de mapeo (simplificado)
  const handleStartMapping = (item) => {
      setCurrentMapping(item);
      setMappingForm({
        versionCliente: item.versionOriginal,
        campanaCliente: item.campanaOriginal,
        segmentoCliente: 'Sin Segmento'
      });
    setShowMappingModal(true);
  };

  // Guardar mapeo
  const handleSaveMapping = async () => {
    if (!currentMapping) {
      console.warn('❌ No hay currentMapping seleccionado');
      return;
    }

    // Validar que los campos requeridos estén completos
    if (!mappingForm.versionCliente || !mappingForm.campanaCliente || !mappingForm.segmentoCliente) {
      setError('Por favor completa todos los campos requeridos (Versión Cliente, Campaña Cliente, Segmento)');
      return;
    }

    setLoading(true);
    
    try {
      const mappingData = {
        ano: selectedPeriod.ano,
        mes: selectedPeriod.mes,
        medioOriginal: currentMapping.medioOriginal,
        versionOriginal: currentMapping.versionOriginal,
        campanaOriginal: currentMapping.campanaOriginal,
        itemOriginal: currentMapping.itemOriginal,
        marcaOriginal: currentMapping.marcaOriginal || null,
        categoryOriginal: currentMapping.categoryOriginal || null,
        versionCliente: mappingForm.versionCliente,
        campanaCliente: mappingForm.campanaCliente,
        segmentoCliente: mappingForm.segmentoCliente
      };

      
      const response = await infomediaService.createMapping(mappingData);
      
      setSuccess(`Mapeo creado exitosamente para ${currentMapping.medioOriginal} - ${currentMapping.versionOriginal}`);
      
      // Cerrar modal SIEMPRE después de éxito
      setShowMappingModal(false);
      setCurrentMapping(null);
      
      
      // ✅ ELIMINACIÓN INTELIGENTE - Solo quitar este registro específico
      const registroEliminado = {
        medioOriginal: currentMapping.medioOriginal,
        versionOriginal: currentMapping.versionOriginal,
        campanaOriginal: currentMapping.campanaOriginal,
        itemOriginal: currentMapping.itemOriginal
      };
      
      
      // ✅ 1. Eliminar de unmappedData (vista actual)
      setUnmappedData(prevData => {
        const nuevaData = prevData.filter(item => !(
          item.medioOriginal === registroEliminado.medioOriginal &&
          item.versionOriginal === registroEliminado.versionOriginal &&
          item.campanaOriginal === registroEliminado.campanaOriginal &&
          item.itemOriginal === registroEliminado.itemOriginal
        ));
        return nuevaData;
      });
      
      // ✅ 2. Eliminar de allDataForSearch (cache completo)
      setAllDataForSearch(prevData => {
        const nuevaData = prevData.filter(item => !(
          item.medioOriginal === registroEliminado.medioOriginal &&
          item.versionOriginal === registroEliminado.versionOriginal &&
          item.campanaOriginal === registroEliminado.campanaOriginal &&
          item.itemOriginal === registroEliminado.itemOriginal
        ));
        
        // ✅ 3. Actualizar contadores si estamos usando filtrado local
        const hasActiveFilters = (
          (filters.search && filters.search.trim()) ||
          (Array.isArray(filters.medio) && filters.medio.length > 0) ||
          (Array.isArray(filters.item) && filters.item.length > 0) ||
          (Array.isArray(filters.sector) && filters.sector.length > 0) ||
          (Array.isArray(filters.marca) && filters.marca.length > 0) ||
          (Array.isArray(filters.categoria) && filters.categoria.length > 0)
        );
        
        if (hasActiveFilters && nuevaData.length > 0) {
          const nuevoTotalPaginas = Math.ceil(nuevaData.length / recordsPerPage);
          setTotalPages(nuevoTotalPaginas);
        }
        
        return nuevaData;
      });
      
              // ✅ 3. Solo recargar mapeos recientes (sin tocar la tabla principal)
        await loadRecentMappings(1);
      

    } catch (err) {
      console.error('❌ Error guardando mapeo:', err);
      setError(`Error guardando mapeo: ${err.message}`);
      
      // NO cerrar el modal en caso de error para que el usuario pueda corregir
    } finally {
      setLoading(false);
    }
  };

  // ✅ ELIMINADO: handleBatchMapping (simplificado sin selección múltiple)

    // ✅ NUEVA FUNCIÓN: Detectar registros nuevos (Proceso 1) 
  const handleDetectNewRecords = async () => {
    const confirmMessage = `¿Buscar nuevos registros para mapear?

Período: ${getMonthName(selectedPeriod.mes)} ${selectedPeriod.ano}

Este proceso buscará campañas y medios que aún no han sido mapeados y los agregará a la lista.

Duración estimada: 15-30 segundos

¿Continuar?`;

    if (!window.confirm(confirmMessage)) {
      return;
    }

    setDetectingLoading(true);
    setError(null);
    
    try {
      
      // Llamar al endpoint de detección (el proceso original)
      const response = await infomediaService.detectUnmapped(selectedPeriod.ano, selectedPeriod.mes);
      
      if (response.data) {
        const stats = response.data;
        const successMessage = `✅ Proceso completado

Se encontraron ${stats.nuevosRegistros || 0} nuevos registros para mapear.

Total pendientes: ${stats.totalSinMapear || 0}
Tarifa total: $${(stats.tarifaTotal || 0).toLocaleString()}

Cambiando a lista de mapeo...`;
        
        setSuccess(successMessage);
        
        // Actualizar progreso con datos reales
        if (stats.totalSinMapear) {
          setMappingProgress(prev => ({
            ...prev,
            pending: stats.totalSinMapear,
            total: (prev.mapped || 0) + stats.totalSinMapear
          }));
        }
        
        // Cambiar a la pestaña de mapeo SIN recargar datos (para evitar loading completo)
        setTimeout(() => {
          setActiveTab('pending');
          // Solo actualizar las estadísticas, no toda la tabla
        }, 2000);
      }

    } catch (err) {
      console.error('❌ Error en detección:', err);
      setError(`Error al buscar registros: ${err.message}`);
    } finally {
      setDetectingLoading(false);
    }
  };

  const getProgressPercentage = () => {
    const total = mappingProgress.mapped + (mappingProgress.filteredPending || mappingProgress.pending);
    if (total === 0) return 0;
    return Math.round((mappingProgress.mapped / total) * 100);
  };

  // const getPriorityColor = (priority) => {
  //   switch (priority) {
  //     case 'ALTA': return 'danger';
  //     case 'MEDIA': return 'warning';
  //     case 'BAJA': return 'info';
  //     default: return 'secondary';
  //   }
  // };

  const formatNumber = (num) => new Intl.NumberFormat('es-ES').format(num);

  if (loading && unmappedData.length === 0) {
    return <MappingSkeleton />;
  }

  return (
    <Container fluid>
      {/* ✅ LOADING OVERLAY CUANDO CAMBIA PERÍODO */}
      {isLoadingPeriod && (
        <div 
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ 
            backgroundColor: 'rgba(0, 0, 0, 0.5)', 
            zIndex: 9999 
          }}
        >
          <div className="bg-white rounded p-4 text-center shadow-lg">
            <Spinner animation="border" variant="primary" className="mb-3" />
            <h5 className="mb-0">Cargando período...</h5>
            <small className="text-muted">Obteniendo datos de {getMonthName(selectedPeriod.mes)} {selectedPeriod.ano}</small>
          </div>
        </div>
      )}
      
      {/* Header */}
      <Row className="align-items-center justify-content-between g-3 mb-4">
        <Col xs="auto">
          <h2 className="text-primary fw-bold mb-0">
            <FontAwesomeIcon icon={faEdit} className="me-2" />
            Mapeo de Datos Infomedia
          </h2>
          <p className="text-muted mb-0">Configura cómo se interpretan los datos de campañas</p>
        </Col>
        <Col xs="auto" className="d-flex gap-2">
          <div className="position-relative" style={{ width: '240px' }}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Buscar período..."
                value={periodSearchTerm || periodOptions.find(option => option.value === `${selectedPeriod.ano}-${selectedPeriod.mes}`)?.label || ''}
                onChange={(e) => {
                  setPeriodSearchTerm(e.target.value);
                  setShowPeriodDropdown(true);
                }}
                onFocus={() => setShowPeriodDropdown(true)}
                onBlur={(e) => {
                  // Delay para permitir clicks en el dropdown
                  setTimeout(() => {
                    if (!e.relatedTarget?.closest('.period-dropdown')) {
                      setShowPeriodDropdown(false);
                      setPeriodSearchTerm('');
                    }
                  }, 150);
                }}
                style={{ 
                  cursor: 'text',
                  backgroundColor: 'white'
                }}
              />
              <InputGroup.Text 
                style={{ cursor: 'pointer' }}
                onClick={() => setShowPeriodDropdown(!showPeriodDropdown)}
              >
                <FontAwesomeIcon icon={showPeriodDropdown ? faChevronUp : faChevronDown} />
              </InputGroup.Text>
            </InputGroup>
            
            {showPeriodDropdown && (
              <div 
                className="period-dropdown position-absolute w-100 bg-white border rounded shadow-sm"
                style={{ 
                  top: '100%', 
                  zIndex: 1060,
                  maxHeight: '200px',
                  overflowY: 'auto'
                }}
              >
                {filteredPeriodOptions.length > 0 ? (
                  filteredPeriodOptions.map((option) => (
                    <div
                      key={option.value}
                      className={`px-3 py-2 cursor-pointer border-bottom ${
                        option.value === `${selectedPeriod.ano}-${selectedPeriod.mes}` 
                          ? 'bg-primary text-white' 
                          : 'hover-bg-light'
                      }`}
                      onClick={() => {
                        const [ano, mes] = option.value.split('-');
                        handlePeriodChange(ano, mes);
                      }}
                      onMouseEnter={(e) => {
                        if (option.value !== `${selectedPeriod.ano}-${selectedPeriod.mes}`) {
                          e.target.style.backgroundColor = '#f8f9fa';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (option.value !== `${selectedPeriod.ano}-${selectedPeriod.mes}`) {
                          e.target.style.backgroundColor = 'white';
                        }
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {option.label}
                    </div>
                  ))
                ) : (
                  <div className="px-3 py-2 text-muted">
                    No se encontraron resultados para "{periodSearchTerm}"
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* DEBUG BUTTON ELIMINADO - Usuario no lo necesita */}
        </Col>
      </Row>

      {/* Alertas */}
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
          {error}
        </Alert>
      )}
      
      {success && (
        <Alert variant="success" dismissible onClose={() => setSuccess(null)}>
          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
          {success}
        </Alert>
      )}

      {/* ✅ ELIMINADO: Indicador de detección (ahora manual en pestaña separada) */}

      {/* Resumen de progreso */}
      <Row className="mb-4">
        <Col lg={4} md={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="fs-1 text-primary me-3">
                  <FontAwesomeIcon icon={faBullseye} />
                </div>
                <div className="flex-grow-1">
                  <h5 className="mb-1">Progreso de Mapeo</h5>
                  <ProgressBar 
                    now={getProgressPercentage()} 
                    variant="primary" 
                    className="mb-2"
                    style={{ height: '8px' }}
                  />
                  <small className="text-muted">
                    {formatNumber(mappingProgress.mapped)} de {formatNumber(mappingProgress.mapped + (mappingProgress.filteredPending || mappingProgress.pending))} registros mapeados ({getProgressPercentage()}%)
                  </small>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={4} md={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="text-center">
              <div className="fs-1 text-warning mb-2">
                <FontAwesomeIcon icon={faExclamationTriangle} />
              </div>
              <h3 className="text-dark fw-bold mb-1">{formatNumber(mappingProgress.filteredPending || mappingProgress.pending)}</h3>
              <p className="text-muted mb-0">
                {mappingProgress.filteredPending !== mappingProgress.pending ? (
                  <>Registros Pendientes (Filtrados)</>
                ) : (
                  <>Registros Pendientes</>
                )}
              </p>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={4} md={6}>
          <Card className="border-0 shadow-sm h-100">
            <Card.Body className="text-center">
              <div className="fs-1 text-success mb-2">
                <FontAwesomeIcon icon={faCheckCircle} />
              </div>
              <h3 className="text-dark fw-bold mb-1">{formatNumber(mappingProgress.mapped)}</h3>
              <p className="text-muted mb-0">Registros Mapeados</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Pestañas principales */}
      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-4">
        <Tab eventKey="detection" title={
          <span>
            <FontAwesomeIcon icon={faSearch} className="me-2" />
             Detectar Nuevos ({getMonthName(selectedPeriod.mes)} {selectedPeriod.ano})
          </span>
        }>
         

          {/* Panel de detección con estadísticas por categoría */}
          <Row>
            <Col md={12}>
              <Card className="border-0 shadow-sm">
                <Card.Header className="bg-primary text-white">
                  <h6 className="mb-0">📊 Estadísticas por Medio</h6>
                </Card.Header>
                <Card.Body>
                  <div className="text-center mb-3">
                    <div className="d-flex flex-column flex-md-row gap-2 justify-content-center">
                    <Button 
                      variant="outline-primary" 
                      size="lg"
                      onClick={() => handleDetectNewRecords()}
                      disabled={detectingLoading}
                    >
                      {detectingLoading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Buscando registros...
                        </>
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faSearch} className="me-2" />
                          Buscar Nuevos Registros
                        </>
                      )}
                    </Button>
                      
                      
                    </div>
                  </div>
                  
                  {/* Estadísticas del último proceso */}
                  <div className="mt-3">
                    <div className="row text-center">
                      <div className="col-6">
                        <div className="border rounded p-2 bg-light">
                          <small className="text-muted d-block">Registros detectados</small>
                          <strong className="text-primary">
                            {mappingProgress.pending?.toLocaleString() || '0'}
                          </strong>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="border rounded p-2 bg-light">
                          <small className="text-muted d-block">Ya mapeados</small>
                          <strong className="text-success">
                            {mappingProgress.mapped?.toLocaleString() || '0'}
                          </strong>
                        </div>
                      </div>
                    </div>
                    <small className="text-muted d-block mt-2 text-center">
                      📅 Último análisis: {new Date().toLocaleDateString()}
                    </small>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            
          
          </Row>
        </Tab>
        
        <Tab eventKey="pending" title={
          <span>
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
            📋 Listos para Mapear ({filteredUnmappedData.length})
          </span>
        }>
          {/* Controles y filtros */}
          <Row className="mb-3 align-items-center g-2">
            <Col md={4}>
            <Form.Label className="mb-1 fw-bold">Buscar:</Form.Label>
             
              <InputGroup style={{ height: '38px' }}>
                <InputGroup.Text style={{ 
                  height: '38px', 
                  display: 'flex', 
                  alignItems: 'center',
                  backgroundColor: '#f8f9fa',
                  borderColor: '#dee2e6'
                }}>
                  <FontAwesomeIcon icon={faSearch} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Buscar campaña, versión o medio..."
                  value={searchTerm}
                  onChange={(e) => handleFilterChange('search', e.target.value)}
                  style={{ 
                    height: '38px',
                    fontSize: '14px'
                  }}
                />
              </InputGroup>
            </Col>

            <Col md={4}>
              <Form.Label className="mb-1 fw-bold">Filtrar por Medios:</Form.Label>
              <MultiSelect
                options={allAvailableMedios.map(m => ({ value: m, label: m }))}
                value={(mediumFilter || []).map(m => ({ value: m, label: m }))}
                onChange={(selected) => {
                  const values = selected ? selected.map(o => o.value) : [];
                  setMediumFilter(values);
                  handleFilterChange('medio', values);
                }}
                placeholder="Selecciona medios..."
                isClearable
                isSearchable
              />
            </Col>
            <Col md={4}>
              <Form.Label className="mb-1 fw-bold">Filtrar por Items:</Form.Label>
              <MultiSelect
                options={filteredItems}
                value={(itemFilter || []).map((v) => ({ value: v, label: v }))}
                onChange={(selected) => {
                  const values = selected ? selected.map((o) => o.value) : [];
                  setItemFilter(values);
                  handleFilterChange('item', values);
                }}
                placeholder="Selecciona items..."
                isClearable
                isSearchable
              />
            </Col>
          </Row>

          {/* FILTRO DE SECTORES Y MARCAS - MULTISELECT */}
          <Row className="mb-3 align-items-center g-2">
            <Col md={4}>
              <Form.Label className="mb-1 fw-bold">Filtrar por Sectores:</Form.Label>
              <MultiSelect
                options={sectorOptions}
                value={sectorFilter.map(sector => ({ value: sector, label: sector }))}
                onChange={(selectedOptions) => {
                  const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
                  setSectorFilter(values);
                  handleFilterChange('sector', values);
                }}
                placeholder="Selecciona sectores..."
                isClearable
                isSearchable
              />
            </Col>
            <Col md={4}>
              <Form.Label className="mb-1 fw-bold">Filtrar por Marcas:</Form.Label>
              <MultiSelect
                options={allAvailableMarcas.map(m => ({ value: m, label: m }))}
                value={(brandFilter || []).map(m => ({ value: m, label: m }))}
                onChange={(selected) => {
                  const values = selected ? selected.map(o => o.value) : [];
                  setBrandFilter(values);
                  handleFilterChange('marca', values);
                }}
                placeholder="Selecciona marcas..."
                isClearable
                isSearchable
              />
            </Col>
            <Col md={4}>
              <Form.Label className="mb-1 fw-bold">Filtrar por Categorías:</Form.Label>
              <MultiSelect
                options={allAvailableCategories.map(c => ({ value: c, label: c }))}
                value={(categoryFilter || []).map(c => ({ value: c, label: c }))}
                onChange={(selected) => {
                  const values = selected ? selected.map(o => o.value) : [];
                  setCategoryFilter(values);
                  handleFilterChange('categoria', values);
                }}
                placeholder="Selecciona categorías..."
                isClearable
                isSearchable
              />
            </Col>
          </Row>

          {/* ✅ BOTONES DE CARGA Y DESCARGA */}
          <Row className="mb-3">
            <Col md={12} className="text-end">
              <Button 
                variant="info" 
                size="sm"
                onClick={downloadUnmappedCSV}
                disabled={detectingLoading}
                className="me-2"
              >
                <FontAwesomeIcon icon={faDownload} className="me-2" />
                Descargar CSV para Mapear
              </Button>
              <Button 
                variant="success" 
                size="sm"
                onClick={() => setShowExcelModal(true)}
                disabled={detectingLoading || uploadingExcel}
                className="me-2"
              >
                <FontAwesomeIcon icon={faUpload} className="me-2" />
                Carga Masiva Excel (Multi-Fecha)
              </Button>
              <small className="text-muted d-block mt-1">
                Descarga CSV para mapear offline o sube Excel con mapeos completos
              </small>
            </Col>
          </Row>

          {/* Lista de registros pendientes */}
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-light">
              <h6 className="mb-0">Registros Pendientes de Mapeo</h6>
            </Card.Header>
            <Card.Body className="p-0">
              {/* ✅ TABLA SIMPLE RESPONSIVE */}
              <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 400px)', overflowY: 'auto', overflowX: 'auto' }}>
                <Table size="sm" className="mb-0" style={{ minWidth: '1100px' }}>
                  <thead className="table-dark sticky-top">
                    <tr>
                      <th style={{ width: '10%', textAlign: 'left' }}>Medio</th>
                      <th style={{ width: '18%', textAlign: 'left' }}>Versión</th>
                      <th style={{ width: '18%', textAlign: 'left' }}>Campaña</th>
                      <th style={{ width: '14%', textAlign: 'left' }}>Item</th>
                      <th style={{ width: '12%', textAlign: 'left' }}>Sector</th>
                      <th style={{ width: '10%', textAlign: 'left' }}>Marca</th>
                      <th style={{ width: '10%', textAlign: 'left' }}>Categoría</th>
                      <th style={{ width: '8%', textAlign: 'center' }}>Registros</th>
                      <th style={{ width: '8%', textAlign: 'right' }}>Tarifa</th>
                      <th style={{ width: '6%', textAlign: 'center' }}>Urgencia</th>
                      <th style={{ width: '6%', textAlign: 'center' }}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="10" className="text-center py-5">
                          <div className="d-flex flex-column align-items-center">
                            <Spinner animation="border" className="mb-3" style={{ width: '3rem', height: '3rem' }} />
                            <h5 className="text-primary mb-2">Cargando página {currentPage}...</h5>
                            <small className="text-muted">Obteniendo registros sin mapear</small>
                          </div>
                        </td>
                      </tr>
                    ) : unmappedData.length === 0 ? (
                      <tr>
                        <td colSpan="10" className="text-center py-4 text-muted">
                          📭 No hay registros sin mapear para este período
                        </td>
                      </tr>
                    ) : (
                      unmappedData.map((item, idx) => (
                        <tr key={idx} className="align-middle">
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns[0].render(item.medioOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns[1].render(item.versionOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns[2].render(item.campanaOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns[3].render(item.itemOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns.find(c => c.key === 'sectorOriginal')?.render(item.sectorOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns.find(c => c.key === 'marcaOriginal')?.render(item.marcaOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            {tableColumns.find(c => c.key === 'categoryOriginal')?.render(item.categoryOriginal, item)}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {tableColumns.find(c => c.key === 'cantidadRegistros')?.render(item.cantidadRegistros, item)}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            {tableColumns.find(c => c.key === 'totalTarifa')?.render(item.totalTarifa, item)}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {tableColumns.find(c => c.key === 'urgencia')?.render(item.urgencia, item)}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            {tableColumns.find(c => c.key === 'actions')?.render(null, item)}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            
            {/* ✅ PAGINACIÓN LIMPIA Y PROFESIONAL */}
            {totalPages > 1 && (
              <Card.Footer className="bg-white border-top">
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Mostrando <strong>{unmappedData.length}</strong> de <strong>{filteredRecordsCount?.toLocaleString() || 0}</strong> registros filtrados
                    </small>
                  
                  <nav aria-label="Navegación de páginas">
                    <ul className="pagination pagination-sm mb-0">
                      <li className={`page-item ${currentPage === 1 || loading ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(1)} disabled={currentPage === 1 || loading}>
                          «
                        </button>
                      </li>
                      <li className={`page-item ${currentPage === 1 || loading ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || loading}>
                          ‹
                        </button>
                      </li>
                      
                      {/* Páginas visibles */}
                      {(() => {
                        const pages = [];
                        let start = Math.max(1, currentPage - 2);
                        let end = Math.min(totalPages, currentPage + 2);
                        
                        // Ajustar para mostrar siempre 5 páginas cuando sea posible
                        if (end - start < 4) {
                          if (start === 1) {
                            end = Math.min(totalPages, start + 4);
                          } else {
                            start = Math.max(1, end - 4);
                          }
                        }
                        
                        for (let i = start; i <= end; i++) {
                          pages.push(
                            <li key={i} className={`page-item ${i === currentPage ? 'active' : ''}`}>
                              <button className="page-link" onClick={() => handlePageChange(i)} disabled={loading}>
                                {i}
                              </button>
                            </li>
                          );
                        }
                        return pages;
                      })()}
                      
                      <li className={`page-item ${currentPage >= totalPages || loading ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages || loading}>
                          ›
                        </button>
                      </li>
                      <li className={`page-item ${currentPage >= totalPages || loading ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handlePageChange(totalPages)} disabled={currentPage >= totalPages || loading}>
                          »
                        </button>
                      </li>
                    </ul>
                  </nav>
                  
                        <small className="text-muted">
                    Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong>
                        </small>
                      </div>
              </Card.Footer>
            )}
          </Card>
        </Tab>

        <Tab eventKey="recent" title={
          <span>
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
            Mapeos Recientes ({recentMappings.length})
          </span>
        }>
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-light d-flex justify-content-between align-items-center">
              <h6 className="mb-0">📋 Mapeos Realizados ({recentMappings.length} de {mappingProgress.mapped})</h6>
                                <div className="d-flex align-items-center">
                    <Button 
                      variant="outline-info" 
                      size="sm"
                      onClick={downloadMappingsCSV}
                      disabled={recentMappings.length === 0}
                      className="me-2"
                    >
                      <FontAwesomeIcon icon={faDownload} className="me-1" />
                      CSV
                    </Button>
                    <Form.Control
                      type="text"
                      placeholder="🔍 Buscar mapeos..."
                      size="sm"
                      style={{ width: '250px', height: '32px' }}
                      value={mappingSearchTerm}
                      onChange={(e) => {
                        setMappingSearchTerm(e.target.value);
                        if (!e.target.value.trim()) {
                          setFilteredMappings(recentMappings);
                        }
                      }}
                    />
                    {searchingMappings && (
                      <Spinner animation="border" size="sm" className="ms-2" />
                    )}
                  </div>
            </Card.Header>
            <Card.Body className="p-0">
              {loadingMappings ? (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status" className="mb-3" />
                  <h6>Cargando mapeos recientes...</h6>
                </div>
              ) : recentMappings.length === 0 ? (
                <div className="text-center py-5">
                  <FontAwesomeIcon icon={faFileExcel} size="3x" className="text-muted mb-3" />
                  <h5>Sin mapeos recientes</h5>
                  <p className="text-muted">Aún no hay mapeos realizados para este período</p>
                </div>
              ) : (
                <>
                  {/* Filtro de mapeos */}
                  {mappingSearchTerm && (
                    <div className="p-3 bg-light border-bottom">
                      <small className="text-muted">
                        🔍 Mostrando {filteredMappings.length} de {mappingTotalRecords} mapeos totales
                        {searchingMappings && <span className="ms-2">🔄 Buscando...</span>}
                      </small>
                    </div>
                  )}
                  
                                    <Table hover responsive className="mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Medio</th>
                        <th>Original</th>
                        <th><FontAwesomeIcon icon={faArrowRight} className="mx-2" /></th>
                        <th>Mapeo Cliente</th>
                        <th>Sector</th>
                        <th>Marca</th>
                        <th>Segmento</th>
                        <th>Fecha</th>
                        <th>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(mappingSearchTerm ? filteredMappings : recentMappings).map((mapping, index) => (
                        <tr key={index}>
                          <td>
                            <Badge 
                              bg={mapping.medioOriginal === 'Internet' ? 'info' : 
                                  mapping.medioOriginal === 'TV' ? 'success' : 
                                  mapping.medioOriginal === 'Radio' ? 'primary' : 'secondary'}
                              className="text-uppercase"
                              style={{ fontSize: '10px' }}
                            >
                              {mapping.medioOriginal}
                            </Badge>
                          </td>
                          <td>
                            <div>
                              <div className="fw-medium">{mapping.versionOriginal}</div>
                              <small className="text-muted">{mapping.campanaOriginal}</small>
                              {mapping.itemOriginal && (
                                <div><small className="text-info">{mapping.itemOriginal}</small></div>
                              )}
                            </div>
                          </td>
                          <td className="text-center">
                            <FontAwesomeIcon icon={faArrowRight} className="text-muted" />
                          </td>
                          <td>
                            <div>
                              <div className="fw-medium text-primary">{mapping.versionCliente}</div>
                              <small className="text-muted">{mapping.campanaCliente}</small>
                            </div>
                          </td>
                          <td>
                            <Badge 
                              bg={mapping.sectorOriginal === 'INTERNET' ? 'info' : 
                                  mapping.sectorOriginal === 'MEDIOS DE COMUNICACIÓN' ? 'warning' : 
                                  mapping.sectorOriginal === 'TELECOMUNICACIONES' ? 'success' : 'secondary'}
                              className="text-white"
                              style={{ fontSize: '11px' }}
                            >
                              {mapping.sectorOriginal || 'SIN SECTOR'}
                            </Badge>
                          </td>
                          <td>
                            <Badge bg="light" text="dark" style={{ fontSize: '11px' }}>
                              {mapping.marcaOriginal || '—'}
                            </Badge>
                          </td>
                          <td>
                            <Badge bg="info">
                              {mapping.segmentoCliente || 'Sin segmento'}
                            </Badge>
                          </td>
                          <td>
                            <small className="text-muted">
                              {new Date(mapping.fechaCreacion).toLocaleDateString('es-ES')}
                            </small>
                          </td>
                          <td>
                            <div className="d-flex gap-1">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleEditMapping(mapping)}
                                title="Editar mapeo"
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => handleDeleteMapping(mapping.id, {
                                  medioOriginal: mapping.medioOriginal,
                                  versionOriginal: mapping.versionOriginal,
                                  campanaOriginal: mapping.campanaOriginal,
                                  itemOriginal: mapping.itemOriginal,
                                  sectorOriginal: mapping.sectorOriginal,
                                  versionCliente: mapping.versionCliente,
                                  campanaCliente: mapping.campanaCliente,
                                  segmentoCliente: mapping.segmentoCliente
                                })}
                                disabled={loading}
                                title="Eliminar mapeo"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  
                  {/* ✅ PAGINACIÓN PARA MAPEOS */}
                  {mappingTotalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center p-3 border-top">
                      <small className="text-muted">
                        Mostrando página {mappingCurrentPage} de {mappingTotalPages} 
                        ({mappingTotalRecords} mapeos total)
                      </small>
                      <div className="btn-group" role="group">
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => loadRecentMappings(1)}
                          disabled={mappingCurrentPage === 1 || loadingMappings}
                        >
                          Primera
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => loadRecentMappings(mappingCurrentPage - 1)}
                          disabled={mappingCurrentPage === 1 || loadingMappings}
                        >
                          Anterior
                        </Button>
                        <span className="px-3 py-2 border bg-light">
                          {mappingCurrentPage} / {mappingTotalPages}
                        </span>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => loadRecentMappings(mappingCurrentPage + 1)}
                          disabled={mappingCurrentPage === mappingTotalPages || loadingMappings}
                        >
                          Siguiente
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => loadRecentMappings(mappingTotalPages)}
                          disabled={mappingCurrentPage === mappingTotalPages || loadingMappings}
                        >
                          Última
                        </Button>
                      </div>
                    </div>
                  )}
                  </>
                )}
              </Card.Body>
            </Card>
          </Tab>
      </Tabs>

      {/* Modal de mapeo */}
      <Modal show={showMappingModal} onHide={() => setShowMappingModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faEdit} className="me-2" />
            Configurar Mapeo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {currentMapping && (
            <>
              <Alert variant="info">
                <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                Configurando mapeo para: <strong>{currentMapping.medioOriginal}</strong> - <strong>{currentMapping.versionOriginal}</strong>
                <br />
                <small>Este mapeo afectará a {formatNumber(currentMapping.cantidadRegistros)} registros</small>
              </Alert>

              <Row>
                <Col md={6}>
                  <Card className="border-light">
                    <Card.Header className="bg-light">
                      <h6 className="mb-0">Datos Originales</h6>
                    </Card.Header>
                    <Card.Body>
                      <ListGroup variant="flush">
                        <ListGroup.Item className="px-0">
                          <strong>Medio:</strong> {currentMapping.medioOriginal}
                        </ListGroup.Item>
                        <ListGroup.Item className="px-0">
                          <strong>Versión:</strong> {currentMapping.versionOriginal}
                        </ListGroup.Item>
                        <ListGroup.Item className="px-0">
                          <strong>Campaña:</strong> {currentMapping.campanaOriginal}
                        </ListGroup.Item>
                        <ListGroup.Item className="px-0">
                          <strong>Item:</strong> {currentMapping.itemOriginal || 'N/A'}
                        </ListGroup.Item>
                        <ListGroup.Item className="px-0">
                          <strong>Marca:</strong> {currentMapping.marcaOriginal || '—'}
                        </ListGroup.Item>
                        <ListGroup.Item className="px-0">
                          <strong>Categoría:</strong> {currentMapping.categoryOriginal || '—'}
                        </ListGroup.Item>
                      </ListGroup>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="border-primary">
                    <Card.Header className="bg-primary text-white">
                      <h6 className="mb-0">Mapeo del Cliente</h6>
                    </Card.Header>
                    <Card.Body>
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Versión del Cliente</Form.Label>
                          <Form.Control
                            value={mappingForm.versionCliente}
                            onChange={(e) => setMappingForm({...mappingForm, versionCliente: e.target.value})}
                            placeholder="Ingrese la versión del cliente"
                          />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                          <Form.Label>Campaña del Cliente</Form.Label>
                          <Form.Control
                            value={mappingForm.campanaCliente}
                            onChange={(e) => setMappingForm({...mappingForm, campanaCliente: e.target.value})}
                            placeholder="Ingrese la campaña del cliente"
                          />
                        </Form.Group>
                        
                        <Form.Group className="mb-3">
                          <Form.Label>Segmento</Form.Label>
                          <Form.Control
                            value={mappingForm.segmentoCliente}
                            onChange={(e) => setMappingForm({...mappingForm, segmentoCliente: e.target.value})}
                            placeholder="Ingrese el segmento (ej: PREMIUM, MASIVO, CORPORATIVO)"
                          />
                          <Form.Text className="text-muted">
                            Campo libre - puede escribir cualquier segmento
                          </Form.Text>
                        </Form.Group>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowMappingModal(false)}>
            Cancelar
          </Button>
                          {false ? ( // ✅ ELIMINADO: mapeo múltiple
            <Button variant="primary" onClick={handleSaveMapping} disabled={loading}>
              {loading && <Spinner animation="border" size="sm" className="me-2" />}
              <FontAwesomeIcon icon={faSave} className="me-1" />
              Guardar Mapeo
            </Button>
          ) : (
            <Button variant="primary" onClick={handleSaveMapping} disabled={loading}>
              {loading && <Spinner animation="border" size="sm" className="me-2" />}
              <FontAwesomeIcon icon={faSave} className="me-1" />
              Guardar Mapeo
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      {/* ✅ MODAL PARA CARGA MASIVA DE EXCEL */}
      <Modal show={showExcelModal} onHide={() => setShowExcelModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faFileExcel} className="me-2 text-success" />
            Carga Masiva de Mapeos desde Excel
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info">
            <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            <strong>Formato requerido del Excel/CSV (MULTI-FECHA):</strong>
            <ul className="mt-2 mb-0">
              <li><strong>Columna A:</strong> ANO (ej: 2024, 2025)</li>
              <li><strong>Columna B:</strong> MES (ej: 1, 2, ..., 12)</li>
              <li><strong>Columna C:</strong> MEDIO (ej: Radio, TV, Internet, Digital)</li>
              <li><strong>Columna D:</strong> VERSIONINFOMEDIA (original)</li>
              <li><strong>Columna E:</strong> CAMPANAINFOMEDIA (original)</li>
              <li><strong>Columna F:</strong> ITEMINFOMEDIA (ej: CNT, CLARO, etc.)</li>
              <li><strong>Columna G:</strong> MARCAINFOMEDIA</li>
              <li><strong>Columna H:</strong> CATEGORIAINFOMEDIA</li>
              <li><strong>Columna I:</strong> VERSIONCLIENTE (mapeo)</li>
              <li><strong>Columna J:</strong> CAMPANACLIENTE (mapeo)</li>
              <li><strong>Columna K:</strong> SEGMENTOCLIENTE</li>
            </ul>
            <div className="alert alert-success mt-2 mb-0">
              <strong>✅ MULTI-FECHA:</strong> Puedes incluir múltiples fechas en el mismo archivo (desde 2024 hasta 2025)
            </div>
            <div className="alert alert-primary mt-2 mb-0">
              <strong>📋 SEPARADORES:</strong> El sistema acepta tanto <strong>coma (,)</strong> como <strong>punto y coma (;)</strong> como separador de columnas.
              Usa punto y coma si tu Excel está en español.
            </div>
            <div className="alert alert-warning mt-2 mb-0">
              <strong>⚠️ IMPORTANTE:</strong> Solo se mapean registros que existan en "Sin Mapear". Si un registro ya fue mapeado o no existe en la base de datos, será omitido.
            </div>
          </Alert>

          <div className="mb-3">
            <Button 
              variant="outline-secondary" 
              size="sm" 
              className="mb-3"
              onClick={() => {
                // Crear y descargar plantilla Excel MULTI-FECHA - ✅ FORMATO CORRECTO CON TODAS LAS COLUMNAS
                // Usar punto y coma (;) como separador para compatibilidad con Excel en español/latinoamérica
                const BOM = '\uFEFF'; // BOM para que Excel detecte UTF-8
                const csvContent = "ANO;MES;MEDIO;VERSIONINFOMEDIA;CAMPANAINFOMEDIA;ITEMINFOMEDIA;MARCAINFOMEDIA;CATEGORIAINFOMEDIA;VERSIONCLIENTE;CAMPANACLIENTE;SEGMENTOCLIENTE\n" +
                  "2024;12;Radio;EJEMPLO VERSION;EJEMPLO CAMPAÑA;CNT;CLARO;SERV. DE CELULARES;VERSION CLIENTE;CAMPAÑA CLIENTE;HOGAR\n" +
                  "2025;1;TV;OTRO EJEMPLO;OTRA CAMPAÑA;SAMSUNG;SAMSUNG;ELECTRODOMESTICOS;OTRA VERSION;OTRA CAMPAÑA CLIENTE;ELECTRONICA\n" +
                  "2025;6;Internet;VERSION JUNIO;CAMPAÑA JUNIO;MOVISTAR;MOVISTAR;PROVEEDOR DE INTERNET;VERSION JUNIO CLIENTE;CAMPAÑA JUNIO CLIENTE;HOGAR";
                
                const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `plantilla_mapeos_multifecha.csv`;
                link.click();
              }}
            >
              <FontAwesomeIcon icon={faDownload} className="me-2" />
              Descargar Plantilla CSV
            </Button>
            <small className="text-muted d-block">
              💡 La plantilla usa punto y coma (;) como separador para compatibilidad con Excel en español. 
              El sistema acepta tanto coma (,) como punto y coma (;).
            </small>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Seleccionar archivo Excel/CSV</Form.Label>
            <Form.Control
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleExcelFileSelect}
              disabled={uploadingExcel}
            />
            {excelFile && (
              <Form.Text className="text-success">
                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                Archivo seleccionado: {excelFile.name}
              </Form.Text>
            )}
          </Form.Group>

          {excelResults && (
            <Alert variant={excelResults.mapped > 0 ? "success" : "warning"}>
              <strong>📊 Resultados de la carga masiva:</strong>
              <Row className="mt-2">
                <Col md={6}>
                  <ul className="mb-0">
                    <li>📋 Total procesados: <strong>{excelResults.processed}</strong></li>
                    <li>✅ Mapeos creados: <strong style={{color: 'green'}}>{excelResults.mapped}</strong></li>
                    <li>⏭️ Ya existían: <strong style={{color: 'orange'}}>{excelResults.omitidos || 0}</strong></li>
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="mb-0">
                    <li>❌ Total errores: <strong style={{color: 'red'}}>{excelResults.errors || 0}</strong></li>
                    <li>&nbsp;&nbsp;• Campos vacíos: <strong>{excelResults.errorFaltaDatos || 0}</strong></li>
                    <li>&nbsp;&nbsp;• No en base: <strong>{excelResults.errorNoExisteFactInfomedia || 0}</strong></li>
                  </ul>
                </Col>
              </Row>
              
              {excelResults.details && excelResults.details.length > 0 && (
                <details className="mt-3">
                  <summary><strong>Ver primeros 20 detalles de errores</strong></summary>
                  <div className="mt-2" style={{maxHeight: '200px', overflowY: 'auto', fontSize: '0.85em'}}>
                    {excelResults.details.slice(0, 20).map((detail, index) => (
                      <div key={index} className="text-muted">• {detail}</div>
                    ))}
                    {excelResults.details.length > 20 && (
                      <div className="text-muted"><em>... y {excelResults.details.length - 20} más</em></div>
                    )}
                  </div>
                  <Button 
                    size="sm" 
                    variant="outline-primary" 
                    className="mt-2"
                    onClick={() => {
                      const csvContent = "Línea,Detalle\n" + 
                        excelResults.details.map(detail => `"${detail.split(':')[0]}","${detail.split(':').slice(1).join(':').trim()}"`).join('\n');
                      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                      const link = document.createElement('a');
                      const url = URL.createObjectURL(blob);
                      link.setAttribute('href', url);
                      link.setAttribute('download', `errores_carga_masiva_${new Date().toISOString().split('T')[0]}.csv`);
                      link.style.visibility = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload} className="me-1" />
                    Descargar errores completos (CSV)
                  </Button>
                </details>
              )}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={() => setShowExcelModal(false)} disabled={uploadingExcel}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleExcelUpload} disabled={!excelFile || uploadingExcel}>
            {uploadingExcel ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Procesando...
              </>
            ) : (
              <>
                <FontAwesomeIcon icon={faUpload} className="me-2" />
                Cargar Mapeos
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ✅ MODAL DE INSTRUCCIONES PARA CSV (WINDOWS/EXCEL) */}
      <Modal show={showCSVInstructionsModal} onHide={() => setShowCSVInstructionsModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faFileExcel} className="me-2 text-info" />
            Instrucciones para Mapeo en Excel (Windows)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="info" className="mb-3">
            <strong>📥 Archivo CSV descargado correctamente</strong>
            <br />
            Siga estas instrucciones para completar el mapeo en Microsoft Excel.
          </Alert>

          <h6 className="mb-3">📋 <strong>Paso 1: Abrir el CSV en Excel</strong></h6>
          <ol>
            <li className="mb-2">Abra <strong>Microsoft Excel</strong></li>
            <li className="mb-2">Vaya a <strong>Archivo → Abrir</strong></li>
            <li className="mb-2">Seleccione el archivo CSV descargado</li>
            <li className="mb-2">En el <strong>Asistente para importar texto</strong>, configure:
              <ul className="mt-2">
                <li><strong>Tipo de archivo:</strong> Delimitado</li>
                <li><strong>Codificación:</strong> UTF-8 (65001: Unicode UTF-8)</li>
                <li><strong>Delimitador:</strong> <span className="badge bg-primary">Punto y coma (;)</span></li>
                <li><strong>Calidad de datos:</strong> General</li>
              </ul>
            </li>
            <li>Haga clic en <strong>Finalizar</strong></li>
          </ol>

          <h6 className="mb-3 mt-4">✏️ <strong>Paso 2: Completar el Mapeo</strong></h6>
          <p className="mb-2">El archivo contiene las siguientes columnas que <strong>DEBE completar</strong>:</p>
          <ul>
            <li><strong>VERSIONCLIENTE</strong> - Versión del cliente</li>
            <li><strong>CAMPANACLIENTE</strong> - Campaña del cliente</li>
            <li><strong>SEGMENTOCLIENTE</strong> - Segmento del cliente</li>
          </ul>
          
          <Alert variant="warning" className="mt-3 mb-3">
            <strong>⚠️ IMPORTANTE:</strong>
            <ul className="mb-0 mt-2">
              <li><strong>NO modifique</strong> las columnas con datos de Infomedia (las primeras 8 columnas)</li>
              <li><strong>NO elimine</strong> filas ni columnas</li>
              <li><strong>NO cambie</strong> el formato del archivo (debe mantenerse como CSV con punto y coma)</li>
              <li>Si una celda está vacía, déjela vacía (no escriba "N/A" o guiones)</li>
            </ul>
          </Alert>

          <h6 className="mb-3 mt-4">💾 <strong>Paso 3: Guardar el Archivo</strong></h6>
          <ol>
            <li className="mb-2">Una vez completado el mapeo, guarde el archivo:
              <ul className="mt-2">
                <li><strong>Archivo → Guardar como</strong></li>
                <li><strong>Tipo:</strong> CSV (delimitado por punto y coma) (*.csv)</li>
                <li><strong>Codificación:</strong> UTF-8 (si se solicita)</li>
              </ul>
            </li>
            <li><strong>NO guarde como Excel (.xlsx)</strong> - debe mantenerse como CSV</li>
          </ol>

          <h6 className="mb-3 mt-4">📤 <strong>Paso 4: Cargar el Archivo Mapeado</strong></h6>
          <ol>
            <li className="mb-2">Regrese a esta página en Galaxy Metrics</li>
            <li className="mb-2">Haga clic en el botón <strong>"Carga Masiva Excel (Multi-Fecha)"</strong></li>
            <li className="mb-2">Seleccione el archivo CSV que acaba de completar</li>
            <li>El sistema procesará el archivo y mostrará los resultados</li>
          </ol>

          <Alert variant="secondary" className="mt-4 mb-0">
            <strong>💡 Tip:</strong> Si los caracteres especiales (ñ, acentos) no se ven correctamente, asegúrese de abrir el CSV con codificación <strong>UTF-8</strong> en Excel.
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowCSVInstructionsModal(false)}>
            Entendido, continuar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default InfomediaMappingInterface;